import React from "react";
import _ConciliationExternalCampaign from "../../components/reports/admin/campaigns/_ConciliationExternalCampaign"
const ConciliationExternalCampaign = () => {
  return (
    <div>
      <_ConciliationExternalCampaign />
    </div>
  );
};

export default ConciliationExternalCampaign;
